// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import store from './store'
import App from './App'
import router from './router'
import axios from '@/axios/index'
import "babel-polyfill"
import xss from 'xss'
import MENUCONFIG from '@/config/menu-config.js' //菜单配置
import MENUAPI from '@/common/menu-common.js' //菜单通用方法
import utils from '@/utils/utils.js'
import dict from '@/common/constant-dict.js'
import filters from '@/filters/index.js'
import {
    Button, Menu, Icon, Layout, Tabs, Form, Input, InputNumber, Dropdown, Table, Modal, Spin, message, Divider, Upload, Select, Breadcrumb, FormModel, DatePicker,
    Popover,
    Checkbox,
    Radio,
    Tag,
    Row,
    Col,
    Steps,
    ConfigProvider, Cascader, Badge, Pagination, Tooltip
} from 'ant-design-vue'
import { Cell, CellGroup, NavBar } from 'vant';

import echarts from 'echarts'
import NProgress from 'nprogress' // 进度条
import fileUpload from "@/components/ui/file-upload/file-upload"
import selectSearch from "@/components/ui/select-search/select-search"
import userAccount from "@/components/user-account/user-account"
import searchForm from "@/components/ui/search-form/search-form"
import editForm from "@/components/ui/edit-form/edit-form"
import buttonLoad from "@/components/ui/button-load"
import imgView from "@/components/ui/img-view"
import startEndDate from "@/components/ui/startEndDate"
import '@/css/app.less'
import '@/css/bank.css'
import 'ant-design-vue/dist/antd.css'
import 'nprogress/nprogress.css'
import '@/assets/icon-fonts/iconfont.css'
import '@/assets/icon-fonts/iconfont.js'
import 'vant/lib/index.css'

// 默认语言为 en-US，如果你需要设置其他语言，推荐在入口文件全局设置 locale
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
Vue.prototype.moment = moment

// 图片预览插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': false, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

// vant
Vue.use(NavBar)
Vue.use(CellGroup)
Vue.use(Cell)
// ant-design-vue
Vue.use(Button)
Vue.use(Icon)
Vue.use(Menu)
Vue.use(Layout)
Vue.use(Tabs)
Vue.use(Form)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Dropdown)
Vue.use(Table)
Vue.use(Modal)
Vue.use(Spin)
Vue.use(Divider)
Vue.use(Upload)
Vue.use(Select)
Vue.use(Breadcrumb)
Vue.use(FormModel)
Vue.use(DatePicker)
Vue.use(Popover)
Vue.use(Checkbox)
Vue.use(Radio)
Vue.use(Tag)
Vue.use(Row)
Vue.use(Col)
Vue.use(Steps)
Vue.use(ConfigProvider)
Vue.use(Cascader)
Vue.use(Badge)
Vue.use(Pagination)
Vue.use(Tooltip)

window.$message = message
Vue.prototype.$message = message
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$destroyAll = Modal.destroyAll;

Vue.prototype.MENUCONFIG = MENUCONFIG
Vue.prototype.MENUAPI = MENUAPI
Vue.prototype.utils = utils
Vue.prototype.dict = dict
Vue.prototype.axios = axios.axios
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

NProgress.configure({
    showSpinner: false
})

Object.keys(filters).forEach(key => { // 全局注册过滤器
    Vue.filter(key, filters[key])
})

Object.defineProperty(Vue.prototype, '$xss', { //添加xss过滤
    value: xss
})


Vue.component("fileUpload", fileUpload)
Vue.component("selectSearch", selectSearch)
Vue.component("userAccount", userAccount)
Vue.component("searchForm", searchForm)
Vue.component("editForm", editForm)
Vue.component("buttonLoad", buttonLoad)
Vue.component("imgView", imgView)
Vue.component("startEndDate", startEndDate)


router.beforeEach((to, from, next) => {
    if (to.fullPath == from.fullPath) {
        return;
    }
    NProgress.start();
    if (!to.meta.public) {  // 判断该路由是否需要登录权限
        if (store.getters["home/getSessionData"] && store.getters["home/getSessionData"].id) {
            // 获取缓存的 请求取消标识 数组，取消所有关联的请求
            let cancelArr = window.axiosCancel || [];
            cancelArr.forEach((ele, index) => {
                ele.cancel("cancel")  // 在失败函数中返回这里自定义的错误信息
                delete window.axiosCancel[index]
            })

            MENUAPI.openOneTab(to.path)
            next();
        } else {
            store.dispatch("home/setSessionAsync")
                .then((res) => {
                    store.dispatch("home/setUserObjAsync")
                        .then((res) => {
                            store.dispatch("home/getPermissonAsync").then(res => {
                                next();
                            })
                        })
                        .catch((err) => {
                            console.log(err)
                        });
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }
    else {
        next();
    }
})
router.afterEach((data) => {
    if (data.path == "/login") {
        if (window.sessionStorage) {
            window.sessionStorage.removeItem("ACTIVEPATH");
            window.sessionStorage.removeItem("ACTIVETABBAR");
            window.sessionStorage.removeItem("OPENEDTABBAR");
            window.localStorage.removeItem("CURRENTROLE");
        }
    }
    NProgress.done();
})


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js